


















import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'DiscountCode',
})
export default class DiscountCode extends Vue {
    private code: string = '';

    private applyCode(): void {
        this.$emit('on-apply-code', this.code);
    }
}
